(function () {
  function clamp(value, min = 0, max = 1) {
    return Math.min(Math.max(value, min), max);
  }

  function rangeProgress(progress, start, end) {
    return clamp((progress - start) / (end - start));
  }

  function initialiseHero(hero) {
    if (!hero || hero.dataset.championReady === "true") return;

    const media = hero.querySelector(".champion-hero__media");
    const intro = hero.querySelector(".champion-hero__intro");
    const story = hero.querySelector(".champion-hero__story");

    if (!media || !intro || !story) return;

    hero.dataset.championReady = "true";

    let ticking = false;

    function setImportant(element, property, value) {
      element.style.setProperty(property, value, "important");
    }

    function update() {
      const rect = hero.getBoundingClientRect();
      const distance = hero.offsetHeight - window.innerHeight;

      if (distance <= 0) {
        ticking = false;
        return;
      }

      const progress = clamp(-rect.top / distance);

      /* Hero remains, then exits upward */
      const introExit = rangeProgress(progress, 0.18, 0.32);

      setImportant(
        intro,
        "opacity",
        String(1 - introExit)
      );

      setImportant(
        intro,
        "transform",
        `translate3d(0, ${-introExit * 150}px, 0)`
      );

      setImportant(intro, "visibility", "visible");

      /* Video-only pause from approximately 32% to 45% */

      const storyEnter = rangeProgress(progress, 0.45, 0.58);
      const storyExit = rangeProgress(progress, 0.84, 1);

      const storyOpacity =
        storyEnter * (1 - storyExit);

      const storyY =
        130 -
        storyEnter * 130 -
        storyExit * 120;

      setImportant(
        story,
        "opacity",
        String(storyOpacity)
      );

      setImportant(
        story,
        "transform",
        `translate3d(0, ${storyY}px, 0)`
      );

      setImportant(story, "visibility", "visible");

      /* Video fades only at the end */
const videoFade = 0;
      setImportant(
        media,
        "opacity",
        String(1 - videoFade)
      );

      ticking = false;
    }

    function requestUpdate() {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener("scroll", requestUpdate, {
      passive: true
    });

    window.addEventListener("resize", requestUpdate);

    update();
  }

  function initialiseAllHeroes() {
    document
      .querySelectorAll("[data-champion-hero]")
      .forEach(initialiseHero);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialiseAllHeroes
    );
  } else {
    initialiseAllHeroes();
  }

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      const hero =
        event.target.querySelector("[data-champion-hero]") ||
        document.querySelector("[data-champion-hero]");

      if (hero) {
        delete hero.dataset.championReady;
        initialiseHero(hero);
      }
    }
  );
})();
/* ======================================================
   COLLECTION INTRO REVEAL + SMOOTH SCROLL
====================================================== */

(function () {
  function initChampionCollectionIntros() {
    const sections = document.querySelectorAll(
      "[data-champion-intro]"
    );

    if (!sections.length) return;

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (reduceMotion || !("IntersectionObserver" in window)) {
      sections.forEach((section) => {
        section.classList.add("is-visible");
      });
    } else {
      const observer = new IntersectionObserver(
        (entries, currentObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add("is-visible");
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.18,
          rootMargin: "0px 0px -8% 0px"
        }
      );

      sections.forEach((section) => {
        observer.observe(section);
      });
    }

    document
      .querySelectorAll("[data-champion-scroll-link]")
      .forEach((link) => {
        if (link.dataset.scrollReady === "true") return;

        link.dataset.scrollReady = "true";

        link.addEventListener("click", function (event) {
          const targetId = link.getAttribute("href");

          if (!targetId || targetId === "#") return;

          const target = document.querySelector(targetId);

          if (!target) return;

          event.preventDefault();

          target.scrollIntoView({
            behavior: reduceMotion ? "auto" : "smooth",
            block: "start"
          });
        });
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initChampionCollectionIntros
    );
  } else {
    initChampionCollectionIntros();
  }

  document.addEventListener(
    "shopify:section:load",
    initChampionCollectionIntros
  );
})();
/* ==========================================
   EXPAND COLLECTION
========================================== */

document.querySelectorAll("[data-expand-grid]").forEach((button) => {
  button.addEventListener("click", () => {
    const hiddenGrid = button
      .closest(".champion-expand-section")
      .nextElementSibling;

    const isOpen = hiddenGrid.classList.toggle("is-open");

    button.classList.toggle("is-open", isOpen);

    button.textContent = isOpen
      ? button.dataset.collapseText
      : button.dataset.expandText;
  });
});
document.addEventListener("DOMContentLoaded", function () {

  const lightbox = document.getElementById("champion-lightbox");
  const lightboxImg = document.getElementById("champion-lightbox-image");
  const closeBtn = document.querySelector(".champion-lightbox-close");

  document.querySelectorAll(".champion-image").forEach(img => {

    img.addEventListener("click", function () {

      lightbox.classList.add("active");

      lightboxImg.src = this.src;

      lightboxImg.alt = this.alt;

      document.body.classList.add("champion-lightbox-open");

    });

  });

  closeBtn.addEventListener("click", function () {

      lightbox.classList.remove("active");

      document.body.classList.remove("champion-lightbox-open");

  });

  lightbox.addEventListener("click", function (e) {

      if (e.target === lightbox) {

          lightbox.classList.remove("active");

          document.body.classList.remove("champion-lightbox-open");

      }

  });

});